export default __webpack_public_path__ + "static/media/download_page_phone_item_telemor.079b5ebb.png";